var app = angular.module('leonardo');

var WorkFlowListFilters = function (
  $scope,
  $state,
  $controller,
  WorkFlowService,
  PermissionService,
  AccountUserService
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.by_unit = $state.current.by_unit;
  $scope.stateUrl = $state.current.url;

  $scope.recurrenceWorkflowStatus = [
    { id: true, name: 'Schedule Enabled' },
    { id: false, name: 'Schedule Disabled' }
  ];

  // for enabling scheduling feature only for greystar
  let AccountIdsScheduleWF = [75, 31];
  
  $scope.checkEnableScheduling = function (){
    if(AccountIdsScheduleWF.includes(AccountUserService.currentAccountUser.account)){
      return true;
    }
    return false;
  }

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1,
          options: $scope.filterService.managers,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account,
          options: $scope.filterService.groups,
          conflicts: ['property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'name',
      name: $scope.by_unit ? 'Unit workflow name' : 'Workflow name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: $scope.by_unit ? 'Unit workflow name' : 'Workflow name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    },
    {
      id: 'role',
      name: 'Role',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      options: $scope.authDataService.getRolesValid(),
      condition: PermissionService.isOwner(),
      conflicts: []
    },
  ];

  if ($scope.by_unit) {
    $scope.filters_options = [
      ...$scope.filters_options,
      {
        id: 'is_unit_turn',
        name: 'Unit Turn',
        label: null,
        inline: false,
        type: 'options',
        multiple: false,
        placeholder: 'Unit Turn',
        condition: true,
        options: WorkFlowService.IS_UNIT_TURN_OPTIONS,
        conflicts: []
      },
      {
        id: 'unit_turn_type',
        name: 'Unit Turn Type',
        label: null,
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Unit Turn Type',
        condition: true,
        options: WorkFlowService.UNIT_TURN_WORKFLOW_OPTIONS,
        conflicts: []
      }
    ];
  }

  if($scope.checkEnableScheduling() && $scope.stateUrl == '/workflows'){
    $scope.filters_options = [
      ...$scope.filters_options,
      // will only enable for schedule workflow
    {
      id: 'recurrence_enable',
      name: 'Status',
      label: 'Status',
      inline: false,
      type: 'options',
      placeholder: 'All Status',
      condition: true,
      options: $scope.recurrenceWorkflowStatus,
      conflicts: []
    }
    ];
  }

  if($scope.checkEnableScheduling() && $scope.stateUrl == '/workflows'){
    $scope.filterService.showFilters(['recurrence_enable']);
    $scope.filterService.setFilter('recurrence_enable', true);
  }
};

app.controller('WorkFlowListFilters', [
  '$scope',
  '$state',
  '$controller',
  'WorkFlowService',
  'PermissionService',
  'AccountUserService',
  WorkFlowListFilters
]);
